import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const SOCIAL = [
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/juan-martin-arrayago/',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
  },
  {
    label: 'GitHub',
    href: 'https://github.com/ArrayagoM',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
      </svg>
    ),
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/juanmartinarrayago/',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg>
    ),
  },
  {
    label: 'WhatsApp',
    href: 'https://wa.me/5492241563807',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    ),
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/juan.arrayago',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
  },
];

const NAV_COLS = [
  {
    title: 'Navegación',
    links: [
      { label: 'Inicio', id: 'index' },
      { label: 'Skills', id: 'skills' },
      { label: 'Servicios', id: 'landingpage' },
      { label: 'Sobre Mí', id: 'about' },
      { label: 'Proyectos', id: 'projects' },
      { label: 'Reviews', id: 'reviews' },
      { label: 'Contacto', id: 'contact' },
    ],
  },
  {
    title: 'Servicios',
    links: [
      { label: 'Desarrollo Web Full Stack', id: 'landingpage' },
      { label: 'IoT & Automatización', id: 'landingpage' },
      { label: 'Integración de IA', id: 'landingpage' },
      { label: 'Deploy & DevOps', id: 'landingpage' },
      { label: 'Apps Móviles', id: 'landingpage' },
      { label: 'Docencia & Talleres', id: 'landingpage' },
    ],
  },
];

const scrollTo = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
};

const Footer = () => (
  <footer style={{ background: '#080808', borderTop: '1px solid rgba(255,69,0,0.12)', paddingTop: '4rem' }}>
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1.5rem' }}>

      {/* Top grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '3rem', marginBottom: '3.5rem' }}>

        {/* Brand col */}
        <div>
          <div style={{ marginBottom: '1rem' }}>
            <span style={{ fontSize: '1.4rem', fontWeight: 900, color: '#f2f2f2', letterSpacing: '-0.5px' }}>
              Tincho<span style={{ color: '#ff4500' }}>Dev</span>
            </span>
          </div>
          <p style={{ color: 'rgba(242,242,242,0.4)', fontSize: '0.83rem', lineHeight: 1.8, marginBottom: '1.25rem', maxWidth: '240px' }}>
            Desarrollador Full Stack & IoT Engineer argentino. Construyo soluciones que conectan hardware, software e inteligencia artificial.
          </p>
          <div style={{ display: 'flex', gap: '0.6rem', flexWrap: 'wrap' }}>
            {SOCIAL.map((s) => (
              <motion.a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                title={s.label}
                whileHover={{ scale: 1.1, y: -2 }}
                whileTap={{ scale: 0.95 }}
                style={{
                  width: '36px', height: '36px', borderRadius: '9px',
                  background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: 'rgba(242,242,242,0.5)', textDecoration: 'none',
                  transition: 'all 0.2s',
                }}
              >
                {s.icon}
              </motion.a>
            ))}
          </div>
        </div>

        {/* Nav cols */}
        {NAV_COLS.map((col) => (
          <div key={col.title}>
            <h4 style={{ color: '#ff4500', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '1.25rem' }}>
              {col.title}
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {col.links.map((link) => (
                <li key={link.label} style={{ marginBottom: '0.6rem' }}>
                  <button
                    onClick={() => scrollTo(link.id)}
                    style={{
                      background: 'none', border: 'none', padding: 0,
                      color: 'rgba(242,242,242,0.45)', fontSize: '0.85rem',
                      cursor: 'pointer', textAlign: 'left',
                      transition: 'color 0.2s',
                    }}
                    onMouseEnter={(e) => e.target.style.color = '#f2f2f2'}
                    onMouseLeave={(e) => e.target.style.color = 'rgba(242,242,242,0.45)'}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))}

        {/* Contact quick */}
        <div>
          <h4 style={{ color: '#ff4500', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '1.25rem' }}>
            Contacto rápido
          </h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            <a href="mailto:juanmartinarrayago@gmail.com" style={{ color: 'rgba(242,242,242,0.45)', fontSize: '0.83rem', textDecoration: 'none', transition: 'color 0.2s' }}
              onMouseEnter={(e) => e.target.style.color = '#f2f2f2'} onMouseLeave={(e) => e.target.style.color = 'rgba(242,242,242,0.45)'}>
              📧 juanmartinarrayago@gmail.com
            </a>
            <a href="https://wa.me/5492241563807" target="_blank" rel="noopener noreferrer"
              style={{ color: 'rgba(242,242,242,0.45)', fontSize: '0.83rem', textDecoration: 'none' }}
              onMouseEnter={(e) => e.target.style.color = '#25d366'} onMouseLeave={(e) => e.target.style.color = 'rgba(242,242,242,0.45)'}>
              💬 WhatsApp: +54 9 2241 56-3807
            </a>
            <p style={{ color: 'rgba(242,242,242,0.3)', fontSize: '0.78rem', lineHeight: 1.6 }}>
              📍 Argentina · Disponible para trabajar remoto
            </p>
          </div>

          {/* Legal links */}
          <div style={{ marginTop: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <Link to="/PrivacyPolicy" style={{ color: 'rgba(242,242,242,0.3)', fontSize: '0.78rem', textDecoration: 'none', transition: 'color 0.2s' }}
              onMouseEnter={(e) => e.target.style.color = '#f2f2f2'} onMouseLeave={(e) => e.target.style.color = 'rgba(242,242,242,0.3)'}>
              Política de Privacidad
            </Link>
            <Link to="/TermsOfService" style={{ color: 'rgba(242,242,242,0.3)', fontSize: '0.78rem', textDecoration: 'none', transition: 'color 0.2s' }}
              onMouseEnter={(e) => e.target.style.color = '#f2f2f2'} onMouseLeave={(e) => e.target.style.color = 'rgba(242,242,242,0.3)'}>
              Términos de Servicio
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div style={{
        borderTop: '1px solid rgba(255,255,255,0.05)',
        padding: '1.5rem 0',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        flexWrap: 'wrap', gap: '0.75rem',
      }}>
        <p style={{ color: 'rgba(242,242,242,0.25)', fontSize: '0.78rem' }}>
          © 2025 <strong style={{ color: 'rgba(242,242,242,0.4)' }}>TinchoDev</strong> — Todos los derechos reservados
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#44ff88', display: 'inline-block', boxShadow: '0 0 6px #44ff88' }} />
          <span style={{ color: 'rgba(242,242,242,0.3)', fontSize: '0.75rem' }}>Disponible para proyectos</span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
